const countryList = [
  {
    text: 'Estonia',
    value: 'estonia'
  },
  {
    text: 'Estonia',
    value: 'Estonia'
  },
  {
    text: 'Russia',
    value: 'russia'
  },
  {
    text: 'Indonesia',
    value: 'indonesia'
  }
]

const nationalityList = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Czechia',
  'Cyprus',
  'Estonia',
  'Denmark',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Italy',
  'Ireland',
  'Latvia',
  'Luxembourg',
  'Lithuania',
  'Malta',
  'Netherlands',
  'Poland',
  'Portugal',
  'Romania',
  'Spain',
  'Slovenia',
  'Sweden',
  'Slovakia',
  'United Kingdom'
]

const monthList = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

const countyList = [
  {
    text: 'Harjumaa',
    value: 'Harjumaa'
  },
  {
    text: 'Hiiumaa',
    value: 'Hiiumaa'
  },
  {
    text: 'Virumaa',
    value: 'Virumaa'
  },
  {
    text: 'Järvamaa',
    value: 'Järvamaa'
  },
  {
    text: 'Läänemaa',
    value: 'Läänemaa'
  },
  {
    text: 'Pärnumaa',
    value: 'Pärnumaa'
  },
  {
    text: 'Põlvamaa',
    value: 'Põlvamaa'
  },
  {
    text: 'Raplamaa',
    value: 'Raplamaa'
  },
  {
    text: 'Saaremaa',
    value: 'Saaremaa'
  },
  {
    text: 'Tartumaa',
    value: 'Tartumaa'
  },
  {
    text: 'Valgamaa',
    value: 'Valgamaa'
  },
  {
    text: 'Viljandimaa',
    value: 'Viljandimaa'
  },
  {
    text: 'Võrumaa',
    value: 'Võrumaa'
  }
]
const unitList = [{
  text: 'm2',
  value: 'm2'
}
]
const internalWallsList = [{
  text: 'Plasterboard',
  value: 'plasterboard'
},
{
  text: 'Stone',
  value: 'stone'
},
{
  text: 'Glass',
  value: 'glass'
},
{
  text: 'Concrete',
  value: 'concrete'
}
]


const conditionListLimited = [
  {
    text: 'New',
    value: 'new'
  },
  {
    text: 'Good',
    value: 'good'
  },
  {
    text: 'Renovated',
    value: 'renovated'
  },
  {
    text: 'Under development',
    value: 'development'
  }
]

const conditionList = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'New',
  value: 'new'
},
{
  text: 'Good',
  value: 'good'
},
{
  text: 'Renovated',
  value: 'renovated'
},
{
  text: 'Sanitary Renovated',
  value: 'sanRenovated'
},
{
  text: 'Average',
  value: 'average'
},
{
  text: 'Needs Sanitary Renovation',
  value: 'needsSanReno'
},
{
  text: 'Needs Full Renovation',
  value: 'needsReno'
},
{
  text: 'Under development',
  value: 'development'
}
]

// [{
//     value: '',
//     text: 'Choose...'
//   }, {
//     text: 'Garage',
//     value: 'garage'
//   },
//   {
//     text: 'Parking Lot',
//     value: 'parkingLot'
//   },
//   {
//     text: 'Studio Apartment',
//     value: 'studio'
//   },
//   {
//     text: 'Penthouse',
//     value: 'penthouse'
//   },
//   {
//     text: 'Apartment',
//     value: 'apartment'
//   },
//   {
//     text: 'House Part',
//     value: 'housePart'
//   },
//   {
//     text: 'Summer House',
//     value: 'summerHouse'
//   },
//   {
//     text: 'Farm House',
//     value: 'farmHouse'
//   },
//   {
//     text: 'Terraced House',
//     value: 'terracedHouse'
//   },
//   {
//     text: 'Pair House',
//     value: 'pairHouse'
//   },
//   {
//     text: 'Single Family House',
//     value: 'detachedOneFamilyHouse'
//   },
//   {
//     text: 'Manor',
//     value: 'manor'
//   },
//   {
//     text: 'Villa',
//     value: 'villa'
//   },
//   {
//     text: 'Accomodation',
//     value: 'accomodation'
//   },
//   {
//     text: 'Bureau',
//     value: 'bureau'
//   },
//   {
//     text: 'Trade',
//     value: 'trade'
//   },
//   {
//     text: 'Warehouse',
//     value: 'warehouse'
//   },
//   {
//     text: 'Warehouse Manufacturing',
//     value: 'warehousemanufacturing'
//   },
//   {
//     text: 'Other',
//     value: 'other'
//   },
//   {
//     text: 'Service',
//     value: 'service'
//   },
//   {
//     text: 'Food Service',
//     value: 'foodService'
//   },
//   {
//     text: 'Residential',
//     value: 'residential'
//   },
//   {
//     text: 'Arable',
//     value: 'arable'
//   },
//   {
//     text: 'Forest',
//     value: 'forest'
//   },
//   {
//     text: 'No Purpose',
//     value: 'noPurpose'
//   },
//   {
//     text: 'Social',
//     value: 'social'
//   },
//   {
//     text: 'Manufacturing',
//     value: 'manufacturing'
//   },
//   {
//     text: 'Business',
//     value: 'business'
//   },
//   {
//     text: 'Transport',
//     value: 'transport'
//   },
//   {
//     text: 'Storage',
//     value: 'storage'
//   },
//   {
//     text: 'Socle',
//     value: 'socle'
//   }
// ]

const subPropertyTypeListApartment = [{
  value: '',
  text: 'Choose...'
},
{
  text: 'Apartment',
  value: 'apartment'
},
{
  text: 'Studio',
  value: 'studio'
},
{
  text: 'Penthouse',
  value: 'penthouse'
},
{
  text: 'Socle',
  value: 'socle'
},
{
  text: '1 BR Apartment',
  value: '1bdApartment'
},
{
  text: '2 BR Apartment',
  value: '2bdApartment'
},
{
  text: '3 BR Apartment',
  value: '3bdApartment'
}
]
const subPropertyTypeListHouse = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'Single Family',
  value: 'detachedOneFamilyHouse'
}, {
  text: 'HousePart',
  value: 'housePart'
}, {
  text: 'Summer House',
  value: 'summerHouse'
}, {
  text: 'Farm House',
  value: 'farmHouse'
}, {
  text: 'Terraced House',
  value: 'terracedHouse'
}, {
  text: 'Pair House',
  value: 'pairHouse'
}, {
  text: 'Manor',
  value: 'manor'
}, {
  text: 'Villa',
  value: 'villa'
}, {
  text: 'House',
  value: 'other'
}
]
const subPropertyTypeListCommercial = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'Accomodation',
  value: 'accomodation'
}, {
  text: 'Bureau',
  value: 'bureau'
}, {
  text: 'Warehouse',
  value: 'warehouse'
}, {
  text: 'Warehouse & Manufacturing',
  value: 'warehousemanufacturing'
}, {
  text: 'Other',
  value: 'other'
}, {
  text: 'Service',
  value: 'service'
}, {
  text: 'Food Service',
  value: 'foodService'
}, {
  text: 'Manufacturing',
  value: 'manufacturing'
}, {
  text: 'Business',
  value: 'business'
}, {
  text: 'Transport',
  value: 'transport'
}, {
  text: 'Storage',
  value: 'storage'
}
]
const subPropertyTypeListLand = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'Other',
  value: 'other'
}, {
  text: 'Residential',
  value: 'residential'
}, {
  text: 'Arable',
  value: 'arable'
}, {
  text: 'Forest',
  value: 'forest'
}, {
  text: 'No Purpose',
  value: 'noPurpose'
}, {
  text: 'Social',
  value: 'social'
}
]

const subPropertyTypeListParking = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'Garage',
  value: 'garage'
}, {
  text: 'Parking Lot',
  value: 'parkingLot'
}, {
  text: 'Other',
  value: 'other'
}
]

const subPropertyTypeList = subPropertyTypeListApartment.concat(subPropertyTypeListHouse, subPropertyTypeListCommercial, subPropertyTypeListParking);

const readinessList = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'Ready',
  value: 'ready'
},
{
  text: 'Closed Box',
  value: 'closedBox'
},
{
  text: 'Roofed Box',
  value: 'roofedBox'
},
{
  text: 'Roofles Box',
  value: 'rooflesBox'
},
{
  text: 'Foundation Only',
  value: 'foundation'
}
]
const suitableList = [{
  text: 'Parties & events allowed',
  value: 'events'
},
{
  text: 'Suitable for children',
  value: 'familyFND'
},
{
  text: 'Disability friendly',
  value: 'disabFND'
},
{
  text: 'Pets Allowed',
  value: 'pets'
},
{
  text: 'Smoking Allowed',
  value: 'smoking'
}
]
const forbittenList = [{
  text: 'No Pets',
  value: 'pets'
},
{
  text: 'No Smoking',
  value: 'smoking'
},
  // {
  //   text: 'Parting',
  //   value: 'party'
  // }
]
const propertyTypeList = [{
  text: 'Apartment',
  value: 'apartment',
  selected: true
},
{
  text: 'House',
  value: 'house',
}
  // {
  //   text: 'Land',
  //   value: 'land',
  //   disabled: true
  // },
  // {
  //   text: 'Commercial',
  //   value: 'commercial',
  //   disabled: true
  // },
  // {
  //   text: 'Parking',
  //   value: 'parking',
  //   disabled: true
  // }
]
const buildingMaterialList = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'Stone',
  value: 'stone'
},
{
  text: 'Wood',
  value: 'wood'
},
{
  text: 'Panel',
  value: 'panel'
},
{
  text: 'Log',
  value: 'log'
},
{
  text: 'Brick',
  value: 'brick'
},
{
  text: 'Field Stone',
  value: 'fieldStone'
},
{
  text: 'Butch Block',
  value: 'butchBlock'
},
{
  text: 'Gravel Block',
  value: 'gravelBlock'
},
{
  text: 'Concrete',
  value: 'concrete'
},
{
  text: 'Metal',
  value: 'metal'
},
{
  text: 'Other',
  value: 'other'
}
]
const balconyTypeList = [{
  text: 'Balcony',
  value: 'balcony'
},
{
  text: 'Terrace',
  value: 'terrace'
}
]
const limitationList = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'Arrest',
  value: 'arrest'
},
{
  text: 'Mortage',
  value: 'mortage'
},
{
  text: 'Protected',
  value: 'protected'
},
{
  text: 'Mortgage',
  value: 'mortgage'
},
{
  text: 'Rent',
  value: 'rent'
},
{
  text: 'Other',
  value: 'other'
}
]
const currencyList = [{
  value: '',
  text: 'Choose...'
}, {
  text: '€',
  value: 'eur'
},
{
  text: '$',
  value: 'usd'
},
{
  text: '£',
  value: 'gbp'
}
]
const statusList = [
  {
    text: 'Expose to portals',
    value: 'active'
  },
  {
    text: 'Archive',
    value: 'archived'
  },
  {
    text: 'Not Public',
    value: 'draft'
  }
]
const statusDescList = [
  {
    text: 'Reason for archiving',
    value: ''
  },
  {
    text: 'Property sold',
    value: 'sold'
  },
  {
    text: 'Rented out',
    value: 'rented'
  },
  {
    text: 'Didn\'t sell',
    value: 'noTransaction'
  },
  {
    text: 'Lets wait',
    value: 'pending'
  }
]
const ownershipTypeList = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'Immoveable',
  value: 'immovable'
},
{
  text: 'Moveable',
  value: 'moveable'
},
{
  text: 'Co Ownership',
  value: 'coOwnership'
},
{
  text: 'Apart Ownership',
  value: 'apartOwnership'
},
{
  text: 'Lease Hold',
  value: 'leaseHold'
},
{
  text: 'Association',
  value: 'association'
},
{
  text: 'Lease Contract',
  value: 'leaseContract'
}
]
const storageTypeList = [{
  text: 'Basement',
  value: 'basement'
},
{
  text: 'Separate Building',
  value: 'sepBuilding'
},
{
  text: 'Storage Room',
  value: 'storeRoom'
}
]
const roofMaterialList = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'Stone',
  value: 'stone'
},
{
  text: 'Shingle',
  value: 'shingle'
},
{
  text: 'Sheet Met',
  value: 'sheetMet'
},
{
  text: 'Profile Met',
  value: 'profileMet'
},
{
  text: 'Tarred Felt',
  value: 'tarredFelt'
},
{
  text: 'Eternit',
  value: 'eternit'
},
{
  text: 'Thatched',
  value: 'thatched'
},
{
  text: 'Gravel Block',
  value: 'gravelBlock'
},
{
  text: 'Bitumen',
  value: 'bitumen'
},
{
  text: 'Other',
  value: 'other'
}
]
const energyLabelList = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'P',
  value: 'P'
},
{
  text: 'A',
  value: 'A'
},
{
  text: 'B',
  value: 'B'
},
{
  text: 'C',
  value: 'C'
},
{
  text: 'D',
  value: 'D'
},
{
  text: 'E',
  value: 'E'
},
{
  text: 'F',
  value: 'F'
},
{
  text: 'G',
  value: 'G'
},
{
  text: 'H',
  value: 'H'
},
{
  text: 'No Certificate',
  value: 'noCertificate'
}
]
const parkingList = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'Free',
  value: 'free'
},
{
  text: 'Pay',
  value: 'pay'
}
]
const waterTypeList = [{
  value: '',
  text: 'Choose...'
}, {
  text: 'Central',
  value: 'central'
},
{
  text: 'Local',
  value: 'local'
}
]
const stovesTypeList = [{
  text: 'Gas',
  value: 'gas'
},
{
  text: 'Wood',
  value: 'wood'
},
{
  text: 'Electric',
  value: 'electric'
},
{
  text: 'Ceramic',
  value: 'ceramic'
},
{
  text: 'Other',
  value: 'other'
}
]
const sanitaryTypeList = [{
  text: 'Bath',
  value: 'bath'
},
{
  text: 'Shower',
  value: 'shower'
},
{
  text: 'Sauna',
  value: 'sauna'
}
]
const heatingsTypeList = [{
  text: 'Local Gas',
  value: 'localGas'
},
{
  text: 'Local Solid',
  value: 'localSolid'
},
{
  text: 'Stove',
  value: 'stove'
},
{
  text: 'Fireplace',
  value: 'fireplace'
},
{
  text: 'Electric',
  value: 'electric'
},
{
  text: 'Electric Floor',
  value: 'electricFloor'
},
{
  text: 'Water Floor',
  value: 'waterFloor'
},
{
  text: 'Central',
  value: 'central'
},
{
  text: 'Central Gas',
  value: 'centralGas'
},
{
  text: 'Aircondition',
  value: 'conditioner'
},
{
  text: 'Ion Heating',
  value: 'ionHeating'
},
{
  text: 'Ground Heating',
  value: 'groundHeating'
},
{
  text: 'Oil Heating',
  value: 'oilHeating'
},
{
  text: 'Combined',
  value: 'combined'
},
{
  text: 'Air Heat Pump',
  value: 'airSourceHeatPump'
}
]
const billingCycle = [
  {
    text: 'Monthly',
    value: 'monthly'
  },
  {
    text: 'Quarterly',
    value: 'quarterly'
  },
  {
    text: 'Annual',
    value: 'annual'
  }
]
const utilityFeesTypeList = [
  {
    text: 'Water',
    value: 'water'
  },
  {
    text: 'Heating',
    value: 'heating'
  },
  {
    text: 'Electricity',
    value: 'electricity'
  },
  {
    text: 'Maintenance & Management',
    value: 'management'
  },
  {
    text: 'Internet',
    value: 'internet'
  },
  {
    text: 'TV subscription',
    value: 'tvSubscription'
  },
  {
    text: 'Gas',
    value: 'gas'
  }
]

const parkingPlacementList = [{
  value: '',
  text: 'Select...'
}, {
  text: 'Garage / Underground',
  value: 'garageunderground'
},
{
  text: 'Courtyard',
  value: 'yard'
},
{
  text: 'Street',
  value: 'street'
}
]
const amenitiesTypeList = [
  {
    text: 'Shower',
    value: 'shower',
  },
  {
    text: 'Bath',
    value: 'bath',
  },
  {
    text: 'Essentials',
    value: 'essentials',
    description: 'Towels, bed sheets, soap, toilet paper, and pillows'
  },
  {
    text: 'Furniture',
    value: 'furniture',
    description: 'Property is fully furnished'
  },
  {
    text: 'Fully furnished kitchen',
    value: 'kitchen'
  },
  {
    text: 'Wardrobe',
    value: 'wardrobe'
  },
  {
    text: 'Air Conditioning',
    value: 'aircon'
  },
  {
    text: 'TV',
    value: 'tvSet'
  },
  {
    text: 'Cable TV',
    value: 'cableTv'
  },
  {
    text: 'Hair Dryer',
    value: 'hairDryer'
  },
  {
    text: 'Washing Machine',
    value: 'washMachine'
  },
  {
    text: 'Dryer',
    value: 'dryer'
  }
]
const workAmenities = [
  {
    text: 'WiFi',
    value: 'wifi'
  },
  {
    text: 'Workspace',
    value: 'WS',
    description: 'A desk with space for a laptop and a comfortable chair'
  },
  {
    text: 'Iron',
    value: 'ironAndBoard'
  }
]
const propertyAmenities = [
  {
    text: 'Disability Friendly',
    value: 'disabiltyFriendly'
  },
  {
    text: 'Elevator',
    value: 'elevator'
  },
  {
    text: 'Gym',
    value: 'gym'
  },
  {
    text: 'Pool',
    value: 'pool'
  },
  {
    text: 'Sauna',
    value: 'sauna'
  }
]

const safetyAmenities = [
  {
    text: 'Neighborhood Watch',
    value: 'neighborhoodWatch'
  },
  {
    text: 'Security Guard',
    value: 'guard'
  },
  {
    text: 'Intercom',
    value: 'intercom'
  },
  {
    text: 'Private Entry',
    value: 'privEnt'
  }
]

const stoveAmenities = [
  {
    text: 'Gas',
    value: 'gasStove'
  },
  {
    text: 'Wood',
    value: 'woodStove'
  },
  {
    text: 'Electric',
    value: 'electricStove'
  },
  {
    text: 'Ceramic',
    value: 'ceramicStove'
  }
]

const amenitiesMap = {
  gasStove: 'stove',
  electricStove: 'stove',
  woodStove: 'stove',
  ceramicStove: 'stove',
  guard: 'safety',
  intercom: 'safety',
  privEnt: 'safety',
  freeParking: 'prop',
  disabiltyFriendly: 'prop',
  elevator: 'prop',
  gym: 'prop',
  sauna: 'prop',
  wifi: 'work',
  WS: 'work',
  ironAndBoard: 'work',
  wifi: 'work',
  shower: 'general',
  bath: 'general',
  essentials: 'general',
  furniture: 'general',
  kitchen: 'general',
  wardrobe: 'general',
  aircon: 'general',
  tvSet: 'general',
  cableTv: 'general',
  hairDryer: 'general',
  washMachine: 'general',
  dryer: 'general'
}
export {
  amenitiesMap,
  stoveAmenities,
  safetyAmenities,
  propertyAmenities,
  workAmenities,
  amenitiesTypeList,
  parkingPlacementList,
  utilityFeesTypeList,
  heatingsTypeList,
  sanitaryTypeList,
  stovesTypeList,
  waterTypeList,
  parkingList,
  energyLabelList,
  roofMaterialList,
  storageTypeList,
  ownershipTypeList,
  statusDescList,
  statusList,
  currencyList,
  limitationList,
  balconyTypeList,
  buildingMaterialList,
  propertyTypeList,
  forbittenList,
  suitableList,
  readinessList,
  subPropertyTypeListParking,
  subPropertyTypeListLand,
  subPropertyTypeListCommercial,
  subPropertyTypeListHouse,
  subPropertyTypeListApartment,
  subPropertyTypeList,
  conditionList,
  conditionListLimited,
  internalWallsList,
  unitList,
  countyList,
  monthList,
  nationalityList,
  countryList,
  billingCycle
}


// WEBPACK FOOTER //
// ./src/lists.js